import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['loader', 'uploadContainer', 'submitButton', 'overlay'];

  connect() {
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.add('hidden');
    }
  }

  showLoader() {
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.remove('hidden');
    }
    if (this.hasUploadContainerTarget) {
      this.uploadContainerTarget.classList.add('hidden');
    }
  }

  hideLoader() {
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.add('hidden');
    }
  }

  showOverlay() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove('hidden');
    }
  }

  hideOverlay() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add('hidden');
    }
  }

  submitEnd(e) {
    this.hideOverlay();
    this.reenableFields();
    if (e.detail.success) {
      this.hideLoader();
    }
  }

  showLoading(event) {
    const button = this.hasSubmitButtonTarget ? this.submitButtonTarget : event.target;
    button.disabled = true;
    button.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>Saving...';
  }

  reenableFields() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.innerHTML = 'Save';
    }
  }

  showLoaderOnClick() {
    this.showLoader();
  }
}